<template>
  <div
    class="absolute right-3 top-[4.25rem] flex flex-col gap-px overflow-hidden rounded-lg bg-bgr shadow-lg"
  >
    <button
      class="flex h-11 w-11 cursor-pointer items-center justify-center border-none bg-bgr text-txt transition-all duration-200 ease-in-out hover:text-thm"
      @click="handleZoomIn"
    >
      <WebccIcon
        class="h-5 w-5 text-txt-weak hover:text-thm"
        name="searchpage/plus-clear"
      />
    </button>

    <div class="h-0.5 w-full border-b bg-bgr"></div>

    <button
      class="flex h-11 w-11 cursor-pointer items-center justify-center border-none bg-bgr text-txt transition-all duration-200 ease-in-out hover:text-thm"
      @click="handleZoomOut"
    >
      <WebccIcon
        class="h-5 w-5 text-txt-weak hover:text-thm"
        name="searchpage/minus-clear"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ map: google.maps.Map }>()

const emit = defineEmits<{
  zoomIn: []
  zoomOut: []
}>()

const handleZoomIn = () => {
  const currentZoom = props.map.getZoom() || 0

  props.map.setZoom(Math.min(currentZoom + 1, 21))

  emit('zoomIn')
}

const handleZoomOut = () => {
  const currentZoom = props.map.getZoom() || 0

  props.map.setZoom(Math.max(currentZoom - 1, 0))

  emit('zoomOut')
}
</script>
